import { ICreateGroupPlayers } from "@grassrootly/api/entities";
import { provider } from "@grassrootly/api/providers";

export interface CreateGroupPlayerData {
  id: number;
  playerId: number;
  name: string;
  group_logo?: string | null;
  created_at: string;
}

export interface CreateGroupPlayerPayload {
  createGroup: CreateGroupPlayerData[];
}

export const CreateGroupPlayer = async (params: CreateGroupPlayerPayload): Promise<ICreateGroupPlayers> =>
  provider.Request("/create-group-player", params);
